export default {
  introTitle: {
    id: 'buyback_swap_v2_category_intro_title',
    defaultMessage: 'Get up to $990 back for trading in your old tech.',
  },
  introItem1: {
    id: 'buyback_swap_v2_category_intro_item_1',
    defaultMessage: 'Get the top offer from 250+ refurbishers.',
  },
  introItem2: {
    id: 'buyback_swap_v2_category_intro_item_2',
    defaultMessage: 'Ship your device for free.',
  },
  introItem3: {
    id: 'buyback_swap_v2_category_intro_item_3',
    defaultMessage: 'Get cash money via direct deposit.',
  },
  smartphonePrice: {
    id: 'buyback_swap_v2_category_price_smartphone',
    defaultMessage: 'Up to $990.00',
  },
  tabletPrice: {
    id: 'buyback_swap_v2_category_price_tablet',
    defaultMessage: 'Up to $650.00',
  },
  macbookPrice: {
    id: 'buyback_swap_v2_category_price_macbook',
    defaultMessage: 'Up to $1100.00',
  },
  audioPrice: {
    id: 'buyback_swap_v2_category_price_audio',
    defaultMessage: 'Up to $200.00',
  },
  consolePrice: {
    id: 'buyback_swap_v2_category_price_console',
    defaultMessage: 'Up to $650.00',
  },
}
